/**
 *
 * @param timeParam in ms
 * @returns {string}
 */
function timeToStringFormat(timeParam) {

  const time = Math.trunc((timeParam / 1000));

  const hours = (Math.trunc(time / 3600)) % 24;
  const minutes = (Math.trunc(time / 60)) % 60;
  const seconds = time % 60;

  const hoursP = hours > 9 ? hours : hours === 0 ? '00' : '0' + hours;
  const minutesP = minutes > 9 ? minutes : minutes === 0 ? '00' : "0" + minutes;
  const secondsP = seconds > 9 ? seconds : seconds === 0 ? '00' : "0" + seconds;
  return `${hoursP}:${minutesP}:${secondsP}`
}


export const timeUtil = {
  timeToStringFormat
}
